import { ScrollSection } from "@/components/main-page/ScrollSection";

export function CareersSection() {
  return (
    <ScrollSection id="careers" title="Join us" compact>
      <div className="max-w-2xl">
        <p className="text-sm text-[var(--color-fg-secondary)] leading-relaxed mb-6">
          We're a small team building something ambitious. If you want to work at the intersection of AI, compliance, and regulated industries, and you're comfortable with the pace and ambiguity of a seed-stage company, we'd like to hear from you.
        </p>
        <p className="text-sm text-[var(--color-fg-secondary)] leading-relaxed mb-8">
          We're always interested in hearing from exceptional engineers, designers, and operators. Send us a note at{" "}
          <a
            href="mailto:careers@cosx.co"
            className="text-[var(--color-fg)] hover:underline"
          >
            careers@cosx.co
          </a>
          {" "}with what you'd bring to COSX.
        </p>
      </div>
    </ScrollSection>
  );
}
